export default __webpack_public_path__ + "media/images/pp_logo_name_xsm-f542ab19ade4ce84dd06c92dd236dfdf.png";